import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { useRoomContext } from "../../context/RoomContext";

interface IOthersRoom {
  id: number;
}

const OthersRooms = (props: IOthersRoom) => {
  const { roomData } = useRoomContext();
  const filteredRooms = roomData.filter((room) => room?.id !== props.id);
  return (
    <>
      <div className="page_content_wrapper" style={{ paddingTop: "30px" }}>
        <div className="singleroom_other_header">
          <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
            <h2>Other Rooms</h2>
            <div className="post_attribute">
              Could also be of interest for you
            </div>
          </Fade>
        </div>

        <Fade direction="up" triggerOnce={true}>
          <div
            className="singleroom_other_rooms custom-singleroom_other_rooms"
            style={{ padding: "0px 80px" }}
          >
            {filteredRooms.map((room) => (
              <div className="room_grid_wrapper one_third">
                <div className="post_img_hover">
                  <img
                    className="singleroom_other_image"
                    src={
                      room?.main_image[0]?.media?.url
                        ? `${process.env.REACT_APP_cmsUrl}${
                            room?.main_image[0]?.media?.url
                          }`
                        : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png"
                    }
                    alt="bayberry_rooms"
                  />
                  <div className="custom-gradient"></div>
                  <Link
                    className="distortion_grid_item-link"
                    to="/our-rooms/rooms-details"
                    state={{
                      id: room.id,
                    }}
                  ></Link>
                </div>
                <h3 className="room_grid_wrapper_header">
                  {room?.room_name}
                </h3>

                {/* <div className="room_grid_attr_wrapper">
                <div className="child_one_third themeborder">
                  <div className="room_attr_value">{room.size}</div>
                  <div className="room_attr_unit">
                    Size
                    <br />
                    m2
                  </div>
                </div>

                <div className="child_one_third themeborder">
                  <div className="room_attr_value">{room.adult}</div>
                  <div className="room_attr_unit">
                    Max
                    <br />
                    Adults
                  </div>
                </div>

                <div className="child_one_third themeborder">
                  <div className="room_attr_value">{room.children}</div>
                  <div className="room_attr_unit">
                    Max
                    <br />
                    Children
                  </div>
                </div>
              </div> */}
                <br className="clear" />
                {/* Remove below margin top if above data is uncomment */}
                <div
                  className="room_grid_link_wrapper"
                  style={{ marginTop: "unset" }}
                >
                  <Link
                    className="room_grid_book"
                    title={`${room?.room_name} Room`}
                    to="/our-rooms/rooms-details"
                    state={{
                      id: room.id,
                    }}
                  >
                    View Details
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </Fade>
      </div>
    </>
  );
};

export default OthersRooms;
